export const ADD_ON_HEADER_TITLE = "Customize your trip";
export const ADD_ON_HEADER_SUBTITLE =
  "Treat yourself to a trip that suits your needs.";
